import { render, staticRenderFns } from "./AddEditDocumentaryRequirements.vue?vue&type=template&id=2ef052e5"
import script from "./AddEditDocumentaryRequirements.vue?vue&type=script&lang=js"
export * from "./AddEditDocumentaryRequirements.vue?vue&type=script&lang=js"
import style0 from "./AddEditDocumentaryRequirements.vue?vue&type=style&index=0&id=2ef052e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports